var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 408.785 408.788",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M353.7 0H55.084A55.085 55.085 0 0 0 0 55.085v298.616a55.084 55.084 0 0 0 55.083 55.085H202.36l.251-146.078H164.66a8.953 8.953 0 0 1-8.954-8.92l-.182-47.087a8.954 8.954 0 0 1 8.92-8.989h37.917v-45.498c0-52.8 32.247-81.55 79.348-81.55h38.65a8.955 8.955 0 0 1 8.954 8.955v39.704a8.955 8.955 0 0 1-8.949 8.955l-23.72.011c-25.614 0-30.574 12.172-30.574 30.035v39.389h56.284a8.955 8.955 0 0 1 8.893 10.009l-5.581 47.087a8.956 8.956 0 0 1-8.892 7.901h-50.453l-.251 146.078h87.631a55.084 55.084 0 0 0 55.084-55.084V55.085A55.086 55.086 0 0 0 353.699 0",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.a36981a732d68f85e2b16295590a6b01.svg";
export { ForwardRef as ReactComponent };